// hooks/useContextMenuState.js
import { useState, useCallback, useEffect } from 'react';

export const useContextMenuState = () => {
    const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0, messageId: null, targetMessage: null });

    const handleContextMenu = useCallback((event, message) => {
        if (!message) { setContextMenu({ visible: false, x: 0, y: 0, messageId: null, targetMessage: null }); return; }
        event.preventDefault(); event.stopPropagation();
        setContextMenu({ visible: true, x: event.clientX, y: event.clientY, messageId: message.id, targetMessage: message });
    }, []);

    useEffect(() => {
        const closeMenu = () => { if (contextMenu.visible) { handleContextMenu(null, null); } };
        window.addEventListener('click', closeMenu);
        return () => window.removeEventListener('click', closeMenu);
    }, [contextMenu.visible, handleContextMenu]);

    const closeContextMenu = useCallback(() => { handleContextMenu(null, null); }, [handleContextMenu]);

    return { contextMenu, handleContextMenu, closeContextMenu };
};